import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  updateGroup(event) {
    event.preventDefault()

    const formaction = event.currentTarget.getAttribute('formaction')
    if (!formaction) return

    const targetUrl = new URL(formaction, window.location.origin)
    const targetGroup = targetUrl.searchParams.get('group') || ''

    const form = event.currentTarget.closest('form')
    if (!form) return

    // Update the hidden group field so the native form submission targets the correct group.
    const groupField = form.querySelector('input[name="group"]')
    if (!groupField) return
    groupField.value = targetGroup

    // Inject any filter params from the current URL that the form doesn't already carry.
    // This preserves filters on 2nd+ tab clicks when the server hasn't pre-populated the selects.
    const formData = new FormData(form)
    for (const [key, value] of new URL(window.location.href).searchParams.entries()) {
      if (key === 'group') continue
      if (!formData.has(key)) {
        const input = document.createElement('input')
        input.type = 'hidden'
        input.name = key
        input.value = value
        form.appendChild(input)
      }
    }

    // Submit natively — this preserves the dropdown visual state the same way main does.
    form.requestSubmit(event.currentTarget)
  }
}
